import Services from "../Components/Services/Services";

const ServicesPage = () => {
  document.body.scrollTop = 0;
  return (
    <div style={{ margin: "3em 0" }}>
      <Services />
    </div>
  );
};

export default ServicesPage;
